import { action, computed, makeObservable, observable } from 'mobx';

import { RouteService } from '../services/RouteService';

import { IModalStore, ModalType } from './ModalStore';
import { Invoice } from './models/Invoice';
import UnsettledReceivablesStore from './UnsettledReceivablesStore';

export interface IInvoicePaymentModalStore {
  readonly successUrl: string;
  readonly failedUrl: string;
  readonly processingUrl: string;
  readonly invoiceNumber: string;
  readonly showDebtNotice: boolean;
  readonly invoice: Invoice;
  readonly amount: number;
  readonly referenceNumber: string;
  readonly isModalLoading: boolean;

  activatePaymentModal(invoiceNumber: string, amount: number, referenceNumber: string): void;
  onModalClose(): void;
}

export class InvoicePaymentModalStore implements IInvoicePaymentModalStore {
  @observable
  public invoiceNumber: string = null;

  @observable
  public amount = 0;

  @observable
  public referenceNumber = '';

  constructor(
    private unsettledReceivablesStore: UnsettledReceivablesStore,
    private modalStore: IModalStore,
    private routeService: RouteService
  ) {
    makeObservable(this);
  }

  @action
  public activatePaymentModal(invoiceNumber: string, amount: number, referenceNumber: string): void {
    this.invoiceNumber = invoiceNumber;
    this.amount = amount;
    this.referenceNumber = referenceNumber;
    this.unsettledReceivablesStore.tryLoadUnsettledReceivables();
    this.modalStore.openModal(ModalType.InvoicePaymentModal);
  }

  @computed
  get showDebtNotice(): boolean {
    return this.unsettledReceivablesStore.hasDebt;
  }

  @computed
  get invoice(): Invoice {
    return this.unsettledReceivablesStore.unpaidInvoice(this.invoiceNumber);
  }

  get successUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/teostatud');
  }

  get failedUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/tuhistatud');
  }

  get processingUrl(): string {
    return this.routeService.createAbsoluteUrl('/arved/tootlemisel');
  }

  onModalClose = (): void => {
    this.routeService.navigateToInvoicePage();
    this.modalStore.closeModal();
  };

  @computed
  get isModalLoading(): boolean {
    return this.unsettledReceivablesStore.unsettledReceivables.isInitialLoading;
  }
}
